/**
 * @file Re-exports the mobile verification request component and its input.
 */
import MobileVerificationRequest from "./MobileVerificationRequest";

export { default as VerificationCodeInput } from "./VerificationCodeInput";

export default MobileVerificationRequest;
